/**
 * Phase flags for the hanging protocol screens.
 *
 * Prior / comparison study authoring ships in a later phase. The document keys
 * (`openAllPriors`, `priorStudyConditions`, a viewport's `priorStudy`, ...) stay
 * in place and are still created, saved and read back untouched, and the planner
 * still carries them out — only the controls that edit them are hidden, so
 * nothing an existing protocol carries is lost while the flag is off.
 *
 * Flip this to `true` to bring back the priors step of the protocol wizard, the
 * priors section of the all-in-one editor, and the prior / other study numbers
 * in the viewport inspector.
 */
export const PRIORS_UI_ENABLED = true;

/**
 * The viewport inspector's "Advance viewer only" tab — MIST/MPR, layout
 * adjustment, PET series, KO instances, auto-applied PRs. These render in the
 * Advance Viewer alone today, so authoring them would promise the basic viewer
 * something it cannot hang. The phase that brings the features to both viewers
 * flips this to `true`; as with priors, the keys themselves are untouched, so a
 * protocol imported from MedDream keeps whatever it already sets here.
 */
export const ADVANCE_VIEWER_UI_ENABLED = true;
